















import { defineComponent, PropType, computed, ref } from "@vue/composition-api";
import { ResponseData } from "../ResponseData";
import { default as ErrorOverlay } from "./error-overlay.vue";
import { ErrorBox } from "@ui";
import { RenderRadio } from "@form-ui";
import { MultipleChoice } from "@psychlab/types/form";
import { getBaseProps } from "./getBaseProps";
import { useRouteTranslate } from "@lang";

export default defineComponent({

	emits:[ "input" ],
	props:{
		value:{
			type:Number
		},
		...getBaseProps<MultipleChoice>(),
		config:{
			type:Object as PropType<MultipleChoice>,
			required:true
		}
	},
	components:{
		RenderRadio,
		ErrorOverlay,
		ErrorBox
	},
	setup(props, context){

		const { translate } = useRouteTranslate(context);

		const pristine = ref(true);

		const val = computed({
			get:() => props.value,
			set:v => context.emit("input", v)
		});

		const state = computed(() => {
			if(val.value === undefined){ return false; }
			if(val.value < 0){ return false; }
			return true;
		});

		const args = computed(() => ({
			title:!props.config.hideName ? props.config.name : '',
			body:props.config.body,
			theme:props.theme,
			options:props.config.settings.options,
		}));

		const isValid = () => {
			pristine.value = false;
			return state.value;
		};

		const getChannels = (prefix:string):ResponseData<number>[] => {
			const v = val.value;
			return v !== undefined ? [
				{
					key: prefix,
					data:v
				}
			] : [];
		};

		const displayOptions = computed(() => {
			let options = props.config.settings.options;
			return options.map((o, i) => {
				return {
					text:o,
					value:i
				}
			})
		});

		const init = () => {
			if(val.value === undefined){ val.value = -1; }
		};

		init();

		return {
			pristine,
			state,
			val,
			displayOptions,
			isValid,
			getChannels,
			args,
			translate,
		};
	}
});

